import { render, staticRenderFns } from "./CommissionTierEditModal.vue?vue&type=template&id=75264b01"
import script from "./CommissionTierEditModal.vue?vue&type=script&lang=js"
export * from "./CommissionTierEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports